module.exports = __webpack_public_path__ + "static/media/2296.aa3f2e42.png";